export const vapidKey = 'BAykFvdljH6BOCwg-X_eyrTOpnqSe_KitPaAuaovp5nJr3ZyzSq3j_0BWYRXil6pO7HCcobmdYZDBjpxBlfwdmE'

export const firebaseConfig = {
	apiKey: 'AIzaSyCagnExonzlDMPZGH4mnEC9RU-ZEX2Mp0w',
	authDomain: 'nbcom-web-push.firebaseapp.com',
	projectId: 'nbcom-web-push',
	storageBucket: 'nbcom-web-push.firebasestorage.app',
	messagingSenderId: '779863110908',
	appId: '1:779863110908:web:a421592e1b41dd47c8d379'
}
